import "@polymer/polymer/polymer-legacy.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "@polymer/paper-input/paper-input.js";
import "@polymer/paper-button/paper-button.js";
import "@polymer/iron-form/iron-form.js";
import "google-recaptcha/google-recaptcha.js";
import "@polymer/paper-spinner/paper-spinner-lite.js";
import "google-recaptcha/iron-scroll-fit.js";
import "@polymer/paper-checkbox/paper-checkbox.js";
import "@polymer/iron-icon/iron-icon.js";
import "./shared-styles.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
class SignUp extends PolymerElement {
    static get template() {
        return html `
            <style>
                #the_form {
                    font-weight: 300;
                    position: relative;
                }

                #the_form p {
                    color: black;
                    font-weight: 500;
                    text-align: center;
                }

                #formContainer {
                    visibility: hidden;
                }

                #errorText {
                    color: #ff3e3e;
                    display: block;
                    text-align: center;
                    font-size: 18px;
                }

                #errorDiv {
                    max-width: 300px;
                }
                #submissionSpinner {
                    z-index: 9999;
                    position: absolute;
                    top: calc(50% - 20px);
                    left: calc(50% - 20px);
                }

                #scrollContainer {
                    height: 200px;
                    overflow: auto;
                    border: 1px solid lightgrey;
                    padding: 5px 10px 0 10px;
                    font-size: 12px;
                    margin-top: 30px;
                }

                paper-checkbox {
                    font-family: "Roboto", sans-serif;
                    font-size: 14px;
                    margin: 20px auto;
                    display: block;
                    width: 80%;
                }

                paper-checkbox:first-child {
                    --primary-color: #ff5722;
                }

                .alert-info {
                    background: #daeeff;
                    border-color: #a8d6fe;
                    color: #0275d8;
                }

                .alert {
                    border: 1px solid transparent;
                    border-radius: 3px;
                    margin-bottom: 20px;
                    margin-top: 20px;
                    padding: 15px;
                    font-size: 12px;
                }

                #submission {
                    display: block;
                    margin: 0 auto;
                    width: 200px;
                    text-align: center;
                    background-color: #2672ae;
                    color: white;
                }

                paper-input {
                    margin-top: 20px;
                }

                a {
                    color: black;
                }

                a:hover {
                    color: #069;
                }

                paper-button[disabled] {
                    background-color: #d8d8d8 !important;
                }
            </style>
            <div id="formContainer">
                <iron-form id="the_form">
                    <p>[[registrationTemplate.title]]</p>
                    <form>
                        <template
                            is="dom-repeat"
                            items="{{registrationTemplate.fields}}"
                        >
                            <paper-input
                                name="[[item.name]]"
                                type="text"
                                label="[[item.label]]"
                                no-label-float="true"
                                required="[[item.required]]"
                            ></paper-input>
                        </template>

                        <!-- custom agreements -->
                        <template
                            is="dom-repeat"
                            items="{{registrationTemplate.agreements}}"
                        >
                            <paper-checkbox id="checkbox" required="">
                                <template
                                    is="dom-repeat"
                                    items="{{parseData(item)}}"
                                >
                                    [[item.txt]]
                                    <template is="dom-if" if="{{item.link}}">
                                        <a
                                            target="_blank"
                                            href="[[item.link.url]]"
                                            >[[item.link.label]]</a
                                        >
                                    </template>
                                </template>
                            </paper-checkbox>
                        </template>
                        <!-- sitesee agreements -->
                        <paper-checkbox id="checkbox" required=""
                            >I agree to the
                            <a
                                target="_blank"
                                href="https://www.sitesee.io/legal/terms-and-conditions"
                                >Terms &amp; Conditions</a
                            ></paper-checkbox
                        >

                        <google-recaptcha
                            value="{{token}}"
                            sitekey="[[siteKey]]"
                            id="captcha"
                            style="margin-left: 20px"
                        >
                        </google-recaptcha
                        ><br />
                        <paper-button id="submission" on-click="submit"
                            >Submit</paper-button
                        >
                        <paper-spinner-lite
                            id="submissionSpinner"
                            class="thin"
                        ></paper-spinner-lite>
                    </form>
                </iron-form>
            </div>
            <h2 id="errorText"></h2>
        `;
    }
    static get is() {
        return "sign-up";
    }
    static get properties() {
        return {
            formData: {
                type: Object,
                value: undefined,
                notify: true,
            },
            registrationTemplate: {
                type: Object,
            },
            apiBaseUrl: {
                type: String,
                notify: true,
            },
            siteKey: {
                type: String,
                notify: true,
            },
            token: {
                type: String,
                value: undefined,
            },
            registrationId: {
                type: String,
                value: null,
            },
            size: {
                type: Number,
                value: 10,
            },
            defaultRegistration: {
                type: Object,
                value: {
                    registrationSubmissionsMessage: "Verification email sent to your submitted email address. Please complete verification prior to logging in.",
                    fields: [
                        {
                            label: "Display Name",
                            name: "displayName",
                            required: true,
                        },
                        {
                            label: "Email",
                            name: "email",
                            required: true,
                        },
                        {
                            label: "First Name",
                            name: "firstName",
                            required: true,
                        },
                        {
                            label: "Last Name",
                            name: "lastName",
                            required: true,
                        },
                    ],
                },
            },
        };
    }
    _scrollHandler() {
        const element = this.$.scrollContainer;
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
            this.$.checkbox.disabled = false;
        }
    }
    parseData(data) {
        const txt = data.template.split("[");
        const out = {
            txt: [txt.shift()],
            linkId: [],
        };
        const split = txt.reduce((acc, t) => {
            const r = t.split("]");
            acc.linkId.push(parseInt(r[0], 10));
            acc.txt.push(r[1]);
            return out;
        }, out);
        const result = split.txt.map((v, i) => {
            if (i < split.linkId.length) {
                return { txt: v, link: data.links[split.linkId[i]] };
            }
            return { txt: v };
        });
        this.acceptData = result;
        return result;
    }
    // eslint-disable-next-line class-methods-use-this
    noAgreements(agreements) {
        if (!agreements)
            return true;
        if (agreements.length === 0)
            return true;
        return false;
    }
    submit() {
        if (this.$.the_form.validate()) {
            const userInfo = this.$.the_form.serializeForm();
            // Build request fields
            const registrationData = {
                workflowId: this.registrationId,
                captchaResponseToken: this.token,
                registrationFields: userInfo,
            };
            this.$.submission.disabled = true;
            this.$.submissionSpinner.active = true;
            this.registrationPost(registrationData)
                .then((data) => {
                const { title, detail } = data;
                this.formData = { response: { title, detail } };
                this.$.captcha.hidden = true;
            })
                .catch((error) => {
                this.$.submission.disabled = false;
                this.$.submissionSpinner.active = false;
                console.log(error);
                this.$.errorText.innerHTML =
                    "An unknown error occurred. If this continues please contact support";
                if (error.error &&
                    error.error.name === "EntityExistsError") {
                    this.$.errorText.innerHTML =
                        "User is already registered";
                }
            });
        }
    }
    async ready() {
        super.ready();
        console.log(this.$.captcha);
        console.log(this.$.captcha.container);
        window.onresize = () => {
            this.resize();
        };
        this.setRegistration();
        await this.getRegistration();
    }
    setRegistration() {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        const registrationId = params.get("id");
        if (registrationId) {
            this.set("registrationId", registrationId);
        }
    }
    resize() {
        this.$.captcha.container.position();
    }
    async getRegistration() {
        const registrationId = this.registrationId || "";
        try {
            const res = await fetch(`${this.apiBaseUrl}/registration/templates/${registrationId}`);
            if (!res.ok) {
                throw res;
            }
            const { data } = await res.json();
            if (!data) {
                console.log("No tenant information");
                this.set("registrationTemplate", this.defaultRegistration);
                console.log(this.defaultRegistration);
                this.$.formContainer.style.visibility = "visible";
                return;
            }
            this.$.formContainer.style.visibility = "visible";
            this.set("registrationTemplate", data);
        }
        catch (error) {
            console.error(error);
            this.$.errorText.innerHTML =
                "An unknown error occurred. If this continues please contact support";
        }
    }
    registrationPost(theData) {
        const init = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            mode: "cors",
            cache: "default",
            credentials: "include",
            body: JSON.stringify(theData),
        };
        return new Promise((resolve, reject) => {
            fetch(`${this.apiBaseUrl}/registration`, init)
                .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                return response.json().then((data) => {
                    return reject(data);
                });
                // return reject(response.statusText);
            })
                .then((data) => {
                return resolve(data);
            });
        });
    }
}
window.customElements.define(SignUp.is, SignUp);
//# sourceMappingURL=registration.js.map